import { defineComponent as _defineComponent } from 'vue'
import { FinancialUserspaces, InviteLinks } from '@busy-human/opt-library';
import { ref, computed, onMounted } from 'vue';
import {meetingConstants} from "@busy-human/opt-library";
import { useUserspace } from '@/store/userspace';
type Props = {
    invite: InviteLinks.Model
    amount: number
    minutes: number
    availabilityLen: number
}

type Emits = {
    (e: "update:amount", amount: number): void
    (e: "update:minutes", minutes: number): void
}

export default /*#__PURE__*/_defineComponent({
  __name: 'rate-field',
  props: {
    invite: null,
    amount: null,
    minutes: null,
    availabilityLen: null
  },
  emits: ["update:amount", "update:minutes"],
  setup(__props: any, { expose, emit }: { emit: ({
    (e: "update:amount", amount: number): void
    (e: "update:minutes", minutes: number): void
}), expose: any, slots: any, attrs: any }) {
  expose();

const props = __props as {
    invite: InviteLinks.Model
    amount: number
    minutes: number
    availabilityLen: number
}

const userFinancial = useUserspace().financial

const MIN_LENGTH     = meetingConstants.MINIMUM_LENGTH;
const MAX_LENGTH     = meetingConstants.MAXIMUM_LENGTH;
const MIN_PRICE      = meetingConstants.MINIMUM_PRICE;
const DEFAULT_PRICE  = meetingConstants.DEFAULT_PRICE;
const MAX_PRICE      = meetingConstants.MAXIMUM_PRICE;





const amount = ref(DEFAULT_PRICE);
const minutes = ref(props.minutes);

onMounted(() => {
    // console.log("amount", props.amount)
    // console.log("DEFUALT:", DEFAULT_PRICE)
    amount.value = DEFAULT_PRICE;
})


const prompt = computed(() => {
    return props.invite.payer ? "I would like to offer" : "My Rate is:"
});
const summaryText = computed(() => {
    return props.invite.payer ? "Total Offer:" : "Total Earnings"
});
//* NOTE: meetings' price and time constants are set in library/Meetings/ *//
const changeAmount = () => {
    if(amount.value < MIN_PRICE){
        console.warn(`Meeting cost cannot be lower than $${MIN_PRICE}`)
        amount.value = MIN_PRICE
    }
    if(amount.value > MAX_PRICE) {
        console.warn(`Meeting cost cannot be greater than $${MAX_PRICE}`);
        amount.value = MAX_PRICE
    }
    emit('update:amount', amount.value)
}

const changeTime = () => {
    // console.log("props", props.availabilityLen)
    if(minutes.value < MIN_LENGTH){
        console.warn("Meeting Duration cannot be lower than MIN_LENGTH minutes")
        minutes.value = MIN_LENGTH
    }
    if(minutes.value > MAX_LENGTH){
        console.warn("Meeting duration cannot be higher than MAX_LENGTH minutes")
        minutes.value = MAX_LENGTH
    }
    if(props.availabilityLen < minutes.value) {
        alert("Meeting Length is greater than your availability time. Meetings won't be able to be created with this meeting link")
    }
    emit('update:minutes', minutes.value)
}

const fee = computed<number>((): number => {
    let fee = FinancialUserspaces.getUserFee(userFinancial)
    return (props.amount * (fee/100))
})

const total = computed(() => {
    const rate = props.amount - fee.value;
    return (Math.round(rate * 100) / 100).toFixed(2);
});


const __returned__ = { userFinancial, MIN_LENGTH, MAX_LENGTH, MIN_PRICE, DEFAULT_PRICE, MAX_PRICE, props, emit, amount, minutes, prompt, summaryText, changeAmount, changeTime, fee, total, FinancialUserspaces, InviteLinks, ref, computed, onMounted, meetingConstants, useUserspace }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})